"use strict";
import format from "../../formatters/general";
export function guessedInvoiceFields(props) {
  var _a, _b, _c, _d;
  const selectedLoad = props.loads.selectedLoad;
  const guessedForLoad = selectedLoad ? (_a = props.documentBatch.guessed_invoice_data_by_load_id) == null ? void 0 : _a[selectedLoad.load.load_id] : null;
  const guessedFromSubmission = props.documentBatch.guessed_invoice_data_from_submission;
  return {
    amount: format.cleanAmount(
      (_b = guessedForLoad == null ? void 0 : guessedForLoad.guessed_invoice_amount) != null ? _b : guessedFromSubmission == null ? void 0 : guessedFromSubmission.guessed_invoice_amount
    ),
    number: (_d = (_c = guessedForLoad == null ? void 0 : guessedForLoad.guessed_invoice_number) != null ? _c : guessedFromSubmission == null ? void 0 : guessedFromSubmission.guessed_invoice_number) != null ? _d : null
  };
}
export function initialInvoiceFieldsState(props) {
  var _a;
  const guessed = guessedInvoiceFields(props);
  return {
    source_invoice_amount: guessed.amount,
    source_invoice_number: guessed.number,
    source_invoice_amount_edited: false,
    source_invoice_number_edited: false,
    prevGuessedInvoiceAmount: guessed.amount,
    prevGuessedInvoiceNumber: guessed.number,
    prevInvoiceGroupId: (_a = props.group) == null ? void 0 : _a.id
  };
}
export function cleanedInvoiceFields(state) {
  return {
    source_invoice_amount: format.cleanAmount(state.source_invoice_amount),
    source_invoice_number: state.source_invoice_number
  };
}
export function invoiceFieldsStateUpdate(props, state) {
  var _a;
  if (((_a = props.group) == null ? void 0 : _a.id) !== state.prevInvoiceGroupId) {
    return initialInvoiceFieldsState(props);
  }
  const guessed = guessedInvoiceFields(props);
  const update = {};
  if (guessed.amount !== state.prevGuessedInvoiceAmount) {
    update.prevGuessedInvoiceAmount = guessed.amount;
    if (!state.source_invoice_amount_edited) {
      update.source_invoice_amount = guessed.amount;
    }
  }
  if (guessed.number !== state.prevGuessedInvoiceNumber) {
    update.prevGuessedInvoiceNumber = guessed.number;
    if (!state.source_invoice_number_edited) {
      update.source_invoice_number = guessed.number;
    }
  }
  return Object.keys(update).length > 0 ? update : null;
}
